import { IncomeStatus, VerifyMethodType } from "shared/types";
import { VerifiedItem } from "../../types/verified";
import { BankSourcesTable } from "./components/BankSourcesTable";
import { PayrollTable } from "./components/PayrollTable";
import { PaystubTable } from "./components/PaystubTable";
import { W2Table } from "./components/W2Table";
import { BankStatementTable } from "./components/BankStatementTable";
import { BankStatementItem } from "../../types/verified/bank-statment";
import { VerificationSpecificAdditionaData } from "../../types/income";
import { BenefitsStatementTable } from "./components/BenefitsStatementTable";

export const TablesSlice = ({
  nonEmptyReverifyAttempt,
  incomeStatus,
  additionalData
}: {
  nonEmptyReverifyAttempt: VerifiedItem | VerifiedItem[];
  incomeStatus: IncomeStatus;
  additionalData?: VerificationSpecificAdditionaData | null;
}) => {
  if (Array.isArray(nonEmptyReverifyAttempt)) {
    const groupedItemsSourceType =
      nonEmptyReverifyAttempt[0].income_source_type;
    if (groupedItemsSourceType === VerifyMethodType.BankStatement)
      return (
        <BankStatementTable
          incomeItems={nonEmptyReverifyAttempt as BankStatementItem[]}
          incomeStatus={incomeStatus}
          additionalData={additionalData?.[VerifyMethodType.BankStatement]}
        />
      );
  } else
    switch (nonEmptyReverifyAttempt.income_source_type) {
      case VerifyMethodType.Bank:
        return <BankSourcesTable income={[nonEmptyReverifyAttempt]} />;
      case VerifyMethodType.Payroll:
        return <PayrollTable income={[nonEmptyReverifyAttempt]} />;
      case VerifyMethodType.W2:
        return <W2Table incomeItems={[nonEmptyReverifyAttempt]} />;
      case VerifyMethodType.Paystub:
        return <PaystubTable incomeItems={[nonEmptyReverifyAttempt]} />;
      case VerifyMethodType.BenefitsStatement:
        return (
          <BenefitsStatementTable incomeItems={[nonEmptyReverifyAttempt]} />
        );
    }
};
